export type FlywayRegion = 'atlantic' | 'mississippi' | 'central' | 'pacific' | 'uk'

export const FLYWAY_REGION_OPTIONS: { value: FlywayRegion; label: string }[] = [
  { value: 'atlantic', label: 'Atlantic' },
  { value: 'mississippi', label: 'Mississippi' },
  { value: 'central', label: 'Central' },
  { value: 'pacific', label: 'Pacific' },
  { value: 'uk', label: 'UK' },
]
